import React, { useRef } from 'react'
import { makeStyles } from '@material-ui/core'
import ActionGroup from '../../shared/ActionGroup'
import { useWealthOwnerDetails, useSectionEditing } from '../ClientDetailsFormContext'
import SectionScreen from '../SectionScreen'
import DeleteButton from '../DeleteButton'
import DeleteDialog from '../DeleteDialog'
import HeaderInfoDisplay from './HeaderInfoDisplay'

const useStyles = makeStyles((theme) => ({
  headerInfo: {
    position: 'relative',
    flex: '1 0'
  }
}))

function HeaderInfo () {
  const classes = useStyles()
  const { wealthOwner, deleteWealthOwner } = useWealthOwnerDetails()
  const editing = useSectionEditing('header')
  const deleteRef = useRef()

  return (
    <SectionScreen sectionName='header' className={classes.headerInfo}>
      <ActionGroup>
        <DeleteButton
          text='Deactivate'
          policy='admin_edit_wo_users'
          disabled={editing}
          onClick={() => deleteRef.current.open()}
        />
      </ActionGroup>
      <HeaderInfoDisplay wealthOwner={wealthOwner} />
      <DeleteDialog
        ref={deleteRef}
        onConfirm={deleteWealthOwner}
      />
    </SectionScreen>
  )
}

export default HeaderInfo
